import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../components/ConfirmModal';
import { useNavigate, useParams } from 'react-router-dom';
import { getPrazoEntregaById, updatePrazoEntrega, deletePrazoEntrega } from '../../services/prazoEntregaService';


const initialState = {
  nome: '',
  status: 'Ativo',
};

const PrazoEntregaEdit = () => {
  const { id } = useParams();
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getPrazoEntregaById(id).then(prazo => {
      console.log('Dados do prazo recebidos:', prazo);
      if (prazo) {
        setForm({ nome: prazo.data.nome, status: prazo.data.status });
      }
      setLoading(false);
    });
  }, [id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setError('');
    // Limpar erro do campo específico
    if (fieldErrors[name]) {
      setFieldErrors({ ...fieldErrors, [name]: '' });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setShowConfirm(true);
  };

  const handleDelete = () => {
    setShowDeleteConfirm(true);
  };

  if (loading) return <div className="max-w-lg mx-auto mt-10 text-blue-600">Carregando dados...</div>;
  if (deleteSuccess) return <div className="max-w-lg mx-auto mt-10 text-green-600">Prazo de entrega excluído com sucesso!</div>;

  return (
    <div className="w-full bg-white rounded shadow p-6 mt-6">
      <h2 className="text-xl font-bold mb-4">Editar Prazo de Entrega</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Nome *</label>
          <input
            type="text"
            name="nome"
            value={form.nome}
            onChange={handleChange}
            maxLength={50}
            className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400 ${fieldErrors.nome ? 'border-red-500' : ''}`}
            placeholder="Nome do prazo de entrega"
          />
          {fieldErrors.nome && <p className="text-red-500 text-xs mt-1">{fieldErrors.nome}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Status *</label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400 ${fieldErrors.status ? 'border-red-500' : ''}`}
          >
            <option value="Ativo">Ativo</option>
            <option value="Inativo">Inativo</option>
          </select>
          {fieldErrors.status && <p className="text-red-500 text-xs mt-1">{fieldErrors.status}</p>}
        </div>
        <div className="flex flex-row gap-1 justify-end mt-2 w-full overflow-x-auto">
          <button type="button" className="p-2 sm:px-4 sm:py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 flex items-center gap-2 w-10 sm:w-auto justify-center" onClick={() => navigate('/prazo-entrega')}>
            <FontAwesomeIcon icon={faTimes} />
            <span className="hidden sm:inline">Cancelar</span>
          </button>
          <button type="submit" className="p-2 sm:px-4 sm:py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 flex items-center gap-2 w-10 sm:w-auto justify-center" aria-label="Salvar">
            <FontAwesomeIcon icon={faSave} />
            <span className="hidden sm:inline">Salvar</span>
          </button>
          <button type="button" className="p-2 sm:px-4 sm:py-2 rounded bg-red-600 text-white font-semibold hover:bg-red-700 flex items-center gap-2 w-10 sm:w-auto justify-center" onClick={handleDelete} disabled={deleting} aria-label="Excluir">
            <FontAwesomeIcon icon={faTrash} />
            <span className="hidden sm:inline">{deleting ? 'Excluindo...' : 'Excluir'}</span>
          </button>
        </div>
      </form>
      <ConfirmModal
        isOpen={showConfirm}
        title="Confirmar Edição"
        message="Deseja realmente salvar as alterações deste prazo de entrega?"
        onCancel={() => setShowConfirm(false)}
        onConfirm={async () => {
          setShowConfirm(false);
          setLoading(true);
          setError('');
          setSuccess(false);
          try {
            await updatePrazoEntrega(id, form);
            setLoading(false);
            setSuccess(true);
            setTimeout(() => navigate('/prazo-entrega'), 1200);
          } catch (err) {
            console.error('Erro ao editar:', err);
            const errorData = err.response?.data;
            
            // Se houver erros de validação específicos dos campos
            if (errorData?.errors && Array.isArray(errorData.errors)) {
              const errors = {};
              errorData.errors.forEach(error => {
                if (error.path) {
                  if (!errors[error.path]) {
                    errors[error.path] = error.msg;
                  }
                }
              });
              setFieldErrors(errors);
            }
            setLoading(false);
          }
        }}
      />
      <ConfirmModal
        isOpen={showDeleteConfirm}
        title="Confirmar Exclusão"
        message="Deseja realmente excluir este prazo de entrega? Esta ação não poderá ser desfeita."
        confirmType="delete"
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={async () => {
          setShowDeleteConfirm(false);
          setDeleting(true);
          try {
            await deletePrazoEntrega(id);
            setDeleting(false);
            setDeleteSuccess(true);
            setTimeout(() => navigate('/prazo-entrega'), 1200);
          } catch (err) {
            setDeleting(false);
            setError('Erro ao excluir prazo.');
          }
        }}
      />
    </div>
  );
};

export default PrazoEntregaEdit;
